/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../auth-context/auth.context";
import { Logout } from "../../../routes";
import { Box, Flex, HStack, Text, useColorModeValue , IconButton, Collapse} from "@chakra-ui/react";
import AuthApi from "../../../api/auth";
import { MdExpandMore, MdExpandLess } from "react-icons/md";

export function SidebarLinks(props) {
  const history = useHistory();
  const { setUser } = useAuth();
  let { user } = useAuth();
  const handleLogout = async () => {
    try {
      await AuthApi.Logout();
    } catch (error) {
      console.error("Error during logout:", error);
    }

    setUser(null);
    localStorage.removeItem("user");
    history.push("/auth/sign-in");
  };

  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  // const { routes } = props;
  const { routes, isCollapsed , onClose } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.toLowerCase().includes(routeName.toLowerCase());
  };
 const [openMenus, setOpenMenus] = React.useState({});

  const toggleMenu = (menuName) => {
    if (isCollapsed) return; // prevent toggling when collapsed
    setOpenMenus((prev) => ({
      ...prev,
      [menuName]: !prev[menuName],
    }));
  };  

//  const createLinks = (routes, openMenus, toggleMenu) => {
//   const location = useLocation();

//   const activeRoute = (routeName) => location.pathname === routeName || location.pathname.startsWith(routeName);

//   return routes.map((route, index) => {
//     if (route.children && route.children.length > 0) {
//       const isOpen = openMenus[route.name] || false;
//       const active = activeRoute(route.layout + route.path);

//       return (
//         <Box key={index} mb={2}>
//           <Flex
//             align="center"
//             justify="space-between"
//             px="10px"
//             py="8px"
//             cursor="pointer"
//             onClick={() => toggleMenu(route.name)}  // toggle submenu open/close
//             _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
//           >
//             <Flex align="center" gap="10px">
//               {route.icon && (
//                 <Box color={active ? "brand.500" : "gray.500"}>
//                   {route.icon}
//                 </Box>
//               )}
//               <Text fontWeight={active ? "bold" : "normal"} color={active ? "brand.500" : "gray.700"}>
//                 {route.name}
//               </Text>
//             </Flex>

//             <IconButton
//               icon={isOpen ? <MdExpandLess /> : <MdExpandMore />}
//               size="sm"
//               variant="ghost"
//               aria-label={isOpen ? "Collapse menu" : "Expand menu"}
//               onClick={(e) => {
//                 e.stopPropagation(); // Prevent toggleMenu on parent Flex from firing
//                 toggleMenu(route.name);
//               }}
//             />
//           </Flex>

//           <Collapse in={isOpen} animateOpacity>
//             <Box pl={6} borderLeft="1px solid" borderColor="gray.200" mt={1}>
//               {/* Render child routes here */}
//               {createLinks(route.children, openMenus, toggleMenu)}
//             </Box>
//           </Collapse>
//         </Box>
//       );
//     }

//     // Single link or child menu item (without children)
//     if (route.layout === "/admin" || route.layout === "/auth" || route.layout === "/rtl") {
//       //const fullPath = route.layout + route.path;
//       const fullPath = `${route.layout}${route.path.startsWith('/') ? route.path : '/' + route.path}`;

//       const active = activeRoute(fullPath);

//       return (
//         <NavLink
//     key={index}
//     to={fullPath}             // <-- This is where the redirection target URL is defined
//     exact
//     style={{ textDecoration: 'none' }}
//     activeStyle={{ fontWeight: "bold", color: "var(--chakra-colors-brand-500)" }}
//   >
//     <Flex
//       align="center"
//       px="10px"
//       py="8px"
//       cursor="pointer"
//       _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
//       color={active ? "brand.500" : "gray.700"}
//     >
//       {route.icon && (
//         <Box color={active ? "brand.500" : "gray.500"} mr="12px">
//           {route.icon}
//         </Box>
//       )}
//       <Text fontWeight={active ? "bold" : "normal"}>
//         {route.name}
//       </Text>
//     </Flex>
//   </NavLink>
//       );
//     }

//     return null;
//   });
// };
  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)

  
 const createLinks = (routes, openMenus = {}, toggleMenu, onClose) => {
  return routes.map((route, index) => {
    // If route has children → expandable menu
    if (route.children && route.children.length > 0) {
      // Check if any child route is active
      const isChildActive = route.children.some(
        (child) => location.pathname === `${child.layout}${child.path}`
      );

      // const isOpen = openMenus[route.name] || false;
      const isOpen = !isCollapsed && (openMenus[route.name] || false);

      return (
        <Box key={index} mb={2}>
          <Flex
            align="center"
            // justify="space-between"
            // px="10px"
            justify={isCollapsed ? "center" : "space-between"}
            px={isCollapsed ? "8px" : "10px"}
            py="8px"
            cursor="pointer"
            onClick={() => toggleMenu(route.name)}
            borderRadius="md"
            // bg={isChildActive ? "#E0EEFF" : "transparent"} // Light blue background for active parent
            bg={isChildActive ? "#E0EEFF" : "transparent"}
            _hover={{ bg: useColorModeValue("gray.100", "gray.700") }}
            title={isCollapsed ? route.name : undefined}
          >
            {/* <Flex align="center" gap="10px"> */}
            <Flex align="center" gap={isCollapsed ? "0" : "10px"} justify={isCollapsed ? "center" : "flex-start"} w="100%">
              {route.icon && (
                <Box
                  // color={isChildActive ? "#4169E1" : "gray.500"} // Royal Blue for active
                  color={isChildActive ? "#4169E1" : "gray.500"}
                  flexShrink={0}
                >
                  {route.icon}
                </Box>
              )}
              {!isCollapsed && (
                <Text
                  fontWeight={isChildActive ? "bold" : "normal"}
                  color={isChildActive ? "#4169E1" : "gray.700"}
                >
                  {route.name}
                </Text>
              )}
            </Flex>
            
            {!isCollapsed && (
              <IconButton
                icon={isOpen ? <MdExpandLess /> : <MdExpandMore />}
                size="sm"
                variant="ghost"
                aria-label={isOpen ? "Collapse" : "Expand"}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMenu(route.name);
                }}
              />
            )}
          </Flex>
          
          {!isCollapsed && (
            <Collapse in={isOpen} animateOpacity>
              <Box pl={6} borderLeft="1px solid" borderColor="gray.200" mt={1}>
                {createLinks(route.children, openMenus, toggleMenu, onClose)}
              </Box>
            </Collapse>
          )}
        </Box>
      );
    }

    // Single route (no children)
    if (route.layout) {
      const fullPath = `${route.layout}${route.path}`;
      const isActive = location.pathname === fullPath;

      return (
        <NavLink key={index} to={fullPath} style={{ textDecoration: "none" }}>
          <Flex
            align="center"
            // px="10px"
            justify={isCollapsed ? "center" : "flex-start"}
            px={isCollapsed ? "8px" : "10px"}
            py="8px"
            borderRadius="md"
            // color={isActive ? "#4169E1" : "gray.700"} // Royal Blue
            color={isActive ? "#4169E1" : "gray.700"}
            fontWeight={isActive ? "bold" : "normal"}
            // _hover={{ color: "#4169E1" }}
            _hover={{ color: "#4169E1", bg: useColorModeValue("gray.100", "gray.700") }}
            title={isCollapsed ? route.name : undefined}
            onClick={() => {
              if (onClose) onClose();
            }}
          >
            {route.icon && (
              <Box
                // color={isActive ? "#4169E1" : "gray.500"} // Royal Blue
                // mr="10px"
                color={isActive ? "#4169E1" : "gray.500"}
                mr={isCollapsed ? "0" : "10px"}
                flexShrink={0}
              >
                {route.icon}
              </Box>
            )}
            {/* <Text>{route.name}</Text> */}
            {!isCollapsed && (
              <Text whiteSpace="nowrap" overflow="hidden">{route.name}</Text>
            )}
          </Flex>
        </NavLink>
      );
    }

    // Category labels / no layout
    return (
      // <Flex key={index} align="center" px="10px" py="8px" color="gray.700">
      //   {route.icon && <Box color="gray.500" mr="10px">{route.icon}</Box>}
      //   <Text>{route.name}</Text>
      // </Flex>
      <Flex key={index} align="center" justify={isCollapsed ? "center" : "flex-start"} px={isCollapsed ? "8px" : "10px"} py="8px" color="gray.700">
        {route.icon && <Box color="gray.500" mr={isCollapsed ? "0" : "10px"} flexShrink={0}>{route.icon}</Box>}
        {!isCollapsed && <Text whiteSpace="nowrap" overflow="hidden">{route.name}</Text>}
      </Flex>
    );
  });
};



  const createLogout = (routes) => {
    return routes.map((route, key) => {
      return (
        <NavLink to={route.layout + route.path} key={key} onClick={handleLogout}>
          {route.icon ? (
            <Flex
              align='center'
              justifyContent='space-between'
              w='100%'
              ps='17px'
              mb='0px'>
              <HStack
                mb='6px'
                spacing={
                  activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                }>
                <Flex w='100%' alignItems='center' justifyContent='center'>
                  <Box
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeIcon
                        : inactiveColor
                    }
                    me='12px'
                    mt='6px'>
                    {route.icon}
                  </Box>
                  <Text
                    me='auto'
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : "secondaryGray.600"
                    }
                    fontWeight='500'>
                    {route.name}
                  </Text>
                </Flex>
              </HStack>
            </Flex>
          ) : (
            <ListItem ms={null}>
              <Flex ps='34px' alignItems='center' mb='8px'>
                <Text
                  color={
                    activeRoute(route.path.toLowerCase())
                      ? activeColor
                      : inactiveColor
                  }
                  fontWeight='500'
                  fontSize='sm'>
                  {route.name}
                </Text>
              </Flex>
            </ListItem>
          )}
        </NavLink>
      );
    });
  };
  //  BRAND
  return (
    <>
      {/* {createLinks(routes)} */}
    {createLinks(routes, openMenus, toggleMenu, onClose)}

      {createLogout(Logout)}

    </>
  );
}

export default SidebarLinks;
